const translations = { selectQuestions: 'Seleção de perguntas', question: 'Pergunta', questions: 'Perguntas' }

export default translations
